// extracted by mini-css-extract-plugin
module.exports = {"efmodal":"CouponModal_efmodal__4_WGx"};